import Text from 'components/Text'
import React from 'react'

export default function TextBodySmall (props) {
  return (
    <Text
      fs='small'
      lh='1.1em'
      {...props}
    />
  )
}
